import { emailSchema, fullNameSchema, phoneNumberSchema } from "utils/schemas";
import * as Yup from "yup";

const schema = Yup.object({
  title: Yup.string().required("The title field is requried"),
  description: Yup.string().required("The description field is required"),
  priorityId: Yup.number().required("The priority field is required"),
  sourceChannelId: Yup.number().nullable().optional(),
  clientId: Yup.number(),
  clientName: fullNameSchema,
  clientEmail: emailSchema,
  clientAddress: Yup.string().required("The address field is required"),
  clientPhone: phoneNumberSchema,
  enquiryIntent: Yup.mixed().required("Enquiry intent is required"),
  status: Yup.string().optional(),
});

export default schema;
